import { Directive } from '@angular/core';

@Directive({
  selector: '[dialogContent], dialogContent',
  standalone: true,
  host: {
    class: 'tt-dialog_content',
  },
})
export class DialogContentDirective {}
